export const soQuy = {
  sections: {
    phieuThuList: { title: 'Cash receipts' },
    phieuThuDetail: { title: 'Receipt detail' },
    phieuChiList: { title: 'Cash payments' },
    phieuChiDetail: { title: 'Payment detail' },
    soQuyList: { title: 'Cash book' },
    baoCao: { title: 'Cash book report' },
    taiKhoanQuy: { title: 'Cash accounts' },
  },
  menu: {
    group: 'Cash book',
    phieuThu: 'Receipts',
    phieuChi: 'Payments',
    soQuy: 'Cash book',
    baoCao: 'Reports',
  },
  phieuThu: {
    title: 'Cash receipt',
    list: 'Receipt list',
    create: 'New receipt',
    update: 'Edit receipt',
    detail: 'Receipt detail',
    hintMaPhieu: 'Receipt code is auto-generated on save.',
    sectionTitles: {
      thongTinPhieu: 'Voucher info',
      thongTinDoiTuong: 'Counterparty info',
      thongTinTaiKhoan: 'Account info',
      thongTinThanhToan: 'Payment info',
      noiDungGhiChu: 'Description & note',
    },
    fields: {
      maPhieu: 'Receipt code',
      thoiGian: 'Time',
      loaiThuChi: 'Receipt type',
      doiTuong: 'Counterparty',
      doiTuongTen: 'Counterparty name',
      doiTuongLoai: 'Counterparty type',
      taiKhoanQuy: 'Cash account',
      soTien: 'Amount',
      noiDung: 'Description',
      ghiChu: 'Note',
      trangThai: 'Status',
      nguoiTao: 'Created by',
      nguoiDuyet: 'Approved by',
      thoiGianTao: 'Created at',
      thoiGianCapNhat: 'Updated at',
      thoiGianDuyet: 'Approved at',
      lyDoTuChoi: 'Rejection reason',
      lyDoHuy: 'Cancellation reason',
      chungTuDinhKem: 'Attachments',
      doiTuongSdt: 'Counterparty phone',
      doiTuongDiaChi: 'Counterparty address',
      soDuTaiThoiDiem: 'Balance at the time',
    },
  },
  phieuChi: {
    title: 'Cash payment',
    list: 'Payment list',
    create: 'New payment',
    update: 'Edit payment',
    detail: 'Payment detail',
    hintMaPhieu: 'Payment code is auto-generated on save.',
    sectionTitles: {
      thongTinPhieu: 'Voucher info',
      thongTinDoiTuong: 'Counterparty info',
      thongTinTaiKhoan: 'Account info',
      thongTinThanhToan: 'Payment info',
      noiDungGhiChu: 'Description & note',
    },
    fields: {
      maPhieu: 'Payment code',
      thoiGian: 'Time',
      loaiThuChi: 'Payment type',
      doiTuong: 'Counterparty',
      doiTuongTen: 'Counterparty name',
      doiTuongLoai: 'Counterparty type',
      taiKhoanQuy: 'Cash account',
      soTien: 'Amount',
      noiDung: 'Description',
      ghiChu: 'Note',
      trangThai: 'Status',
      nguoiTao: 'Created by',
      nguoiDuyet: 'Approved by',
      thoiGianTao: 'Created at',
      thoiGianCapNhat: 'Updated at',
      thoiGianDuyet: 'Approved at',
      lyDoTuChoi: 'Rejection reason',
      lyDoHuy: 'Cancellation reason',
      chungTuDinhKem: 'Attachments',
      doiTuongSdt: 'Counterparty phone',
      doiTuongDiaChi: 'Counterparty address',
      soDuTaiThoiDiem: 'Balance at the time',
    },
  },
  // Story 3.3 — Unified Cash Book page (FR-10).
  // i18n key structure mirrors `phieuThu` / `phieuChi` for consistency.
  unified: {
    title: 'Cash book',
    list: 'Cash book',
    tabs: {
      all: 'All',
      thu: 'Receipts',
      chi: 'Payments',
    },
    fields: {
      loai: 'Type',
      loaiThuChi: 'Receipt type',
    },
    summary: {
      title: 'Total receipts / Total payments / Net (full filter — approved)',
      tongThu: 'Total receipts',
      tongChi: 'Total payments',
      chenhLech: 'Net',
    },
  },
  trangThai: {
    NHAP: 'Draft',
    CHO_DUYET: 'Pending approval',
    DA_DUYET: 'Approved',
    HUY: 'Cancelled',
  },
  loai: { THU: 'Receipt', CHI: 'Payment' },
  loaiTaiKhoan: {
    TIEN_MAT: 'Cash',
    NGAN_HANG: 'Bank account',
  },
  doiTuongLoai: {
    KHACH_HANG: 'Customer',
    NHA_CUNG_CAP: 'Supplier',
    NGUOI_DUNG: 'Employee',
    TU_DO: 'Other',
  },
  actions: {
    luu: 'Save draft',
    luuThayDoi: 'Save changes',
    dong: 'Close',
    quayLai: 'Back to list',
    taoPhieuThu: 'New receipt',
    taoPhieuChi: 'New payment',
    sua: 'Edit',
    guiDuyet: 'Submit for approval',
    duyet: 'Approve',
    tuChoi: 'Reject',
    huy: 'Cancel',
    xoa: 'Delete',
    in: 'Print',
    xuatExcel: 'Export Excel',
    xem: 'View',
    taiLai: 'Reload',
    datLaiBoLoc: 'Reset filters',
  },
  messages: {
    banner: {
      choDuyet: 'Voucher is pending approval.',
      daDuyet: 'Voucher was approved by {nguoiDuyet} at {thoiGian}.',
      huy: 'Voucher was cancelled. Reason: {lyDo}.',
    },
    taoThanhCong: 'Receipt {maPhieu} created.',
    suaThanhCong: 'Receipt {maPhieu} updated.',
    guiDuyetThanhCong: 'Receipt {maPhieu} submitted for approval.',
    duyetThanhCong: 'Receipt {maPhieu} approved.',
    tuChoiThanhCong: 'Receipt {maPhieu} rejected.',
    huyThanhCong: 'Receipt {maPhieu} cancelled.',
    loadError: 'Could not load the receipt list.',
    loadErrorChi: 'Could not load the payment list.',
    chiTietLoadError: 'Could not load the receipt detail.',
    auditLoadError: 'Could not load the audit timeline.',
    notFound: 'Receipt not found.',
    khongCoQuyen: 'You do not have permission to perform this action.',
    xungDotVersion: 'Receipt was modified by someone else. Please reload.',
    loiHeThong: 'System error. Please try again later. (Code: {code})',
    chuaCoPhieu: 'No receipts yet.',
    chuaCoPhieuChi: 'No payments yet.',
    chuaCoPhieuKhopLoc: 'No receipts match the filters.',
    chuaCoPhieuKhopLocChi: 'No payments match the filters.',
    // Story 3.3 — Empty state for the unified page.
    chuaCoPhieuUnified: 'No vouchers in the cash book yet.',
    chuaCoTaiKhoanQuy: 'No cash accounts yet. Contact super admin.',
    dangPhatTrien: 'Page under development ({story}).',
    canhBaoSoDuAm:
      'Balance after payment: {soDuSauKhiChi} (negative). You can still create the voucher; manager will consider when approving.',
    guiDuyetThanhCongChi: 'Payment {maPhieu} submitted for approval.',
    duyetThanhCongChi: 'Payment {maPhieu} approved.',
    tuChoiThanhCongChi: 'Payment {maPhieu} rejected.',
    huyThanhCongChi: 'Payment {maPhieu} cancelled.',
    xoaThanhCong: 'Deleted draft receipt {maPhieu}.',
    xoaThanhCongChi: 'Deleted draft payment {maPhieu}.',
    taoThanhCongChi: 'Payment {maPhieu} created.',
    suaThanhCongChi: 'Payment {maPhieu} updated.',
    xacNhan: {
      guiDuyet: 'Submit receipt {maPhieu} for approval?',
      guiDuyetChi: 'Submit payment {maPhieu} for approval?',
      duyet: 'Approve receipt {maPhieu}? Balance of {taiKhoanQuy} will increase by +{soTien}.',
      duyetChi: 'Approve payment {maPhieu}? Balance of {taiKhoanQuy} will decrease by -{soTien}.',
      duyetChiKhongDuQuy:
        '{taiKhoanQuy} only has {soDu}, not enough to pay {soTien}. This payment cannot be approved.',
      tuChoi: 'Reject receipt {maPhieu}? Creator will be notified.',
      tuChoiChi: 'Reject payment {maPhieu}? Creator will be notified.',
      huy: 'Cancel approved receipt {maPhieu}? Balance will decrease by -{soTien}.',
      huyChi: 'Cancel approved payment {maPhieu}? Balance will be refunded +{soTien}.',
      xoa: 'Delete draft receipt {maPhieu}? It will be permanently removed.',
      xoaChi: 'Delete draft payment {maPhieu}? It will be permanently removed.',
    },
  },
  filters: {
    hintSection: 'Receipt filters',
    hintBody: 'Filter by status, time, cash account, receipt type, creator, counterparty.',
    trangThai: 'Status',
    thoiGian: 'Time',
    taiKhoanQuy: 'Cash account',
    loaiThuChi: 'Receipt type',
    nguoiTao: 'Creator',
    doiTuong: 'Counterparty',
    chiNhanh: 'Branch',
    homNay: 'Today',
    tuanNay: 'This week',
    thangNay: 'This month',
    quyNay: 'This quarter',
    namNay: 'This year',
    tuyChinh: 'Custom',
    // Story 3.3 — "Type (Receipt/Payment)" sidebar (unified list only).
    loaiAll: 'All',
    loaiThu: 'Receipts',
    loaiChi: 'Payments',
    // Story 3.3 review patch — Section title (resolve i18n tautology).
    loaiThuChiSection: 'Type (Receipt/Payment)',
    taiKhoanQuyAll: 'All cash accounts',
    taiKhoanQuySearch: 'Search cash accounts',
    taiKhoanQuyEmpty: 'No cash accounts',
    dateRangePlaceholder: 'Select date range',
    loaiThuChiAll: 'All types',
    loaiThuChiSearch: 'Search receipt types',
    loaiThuChiEmpty: 'No receipt types',
    nguoiTaoAll: 'All creators',
    nguoiTaoSearch: 'Search creators',
    nguoiTaoEmpty: 'No creators',
  },
  filter: {
    searchPlaceholder: 'Search by receipt code, counterparty, description...',
    textDetailTitle: 'Detailed filters',
  },
  validation: {
    soTienRequired: 'Please enter an amount.',
    soTienInvalid: 'Amount must be greater than 0.',
    taiKhoanQuyRequired: 'Please select a cash account.',
    thoiGianRequired: 'Please select a time.',
    thoiGianFuture: 'Time cannot be in the future.',
    noiDungRequired: 'Please enter a description.',
    doiTuongIdRequired: 'Please select a counterparty from the list.',
    chuaXacDinhChiNhanh: 'Branch is not set. Please contact an administrator.',
    lyDoTuChoiRequired: 'Please enter a rejection reason (10–500 characters).',
    lyDoHuyRequired: 'Please enter a cancellation reason (20–500 characters).',
    doiTuongTenRequired: 'Please enter a counterparty name (at least 3 characters).',
    lyDoMinLength: 'Minimum {n} characters.',
    lyDoMinLengthLabel: 'min. {n} characters',
    // Code review 1.10 patches:
    taiDuLieuThatBai: 'Failed to load data. Please close and reopen the form.',
    noiDungQuaDai: 'Description is too long (maximum 1000 characters).',
    ghiChuQuaDai: 'Note is too long (maximum 2000 characters).',
  },
  printTemplate: {
    title: 'CASH RECEIPT',
    titleChi: 'CASH PAYMENT',
    ngayThangNam: 'Day {ngay} month {thang} year {nam}',
    soTien: 'Amount',
    soTienBangChu: 'Amount in words: {chu}',
    nguoiLap: 'Prepared by',
    thuQuy: 'Cashier',
    nguoiNhan: 'Recipient',
    keToanTruong: 'Chief accountant',
    giamDoc: 'Director',
    // Story 3.4 — extend print template (FR-13). 29 new keys.
    printButton: 'Print voucher',
    closeButton: 'Close',
    printPreviewTitle: 'Print preview',
    printLoadingData: 'Loading print data...',
    printNotSupported: 'Browser does not support printing. Please use Chrome/Edge/Firefox.',
    printMobileWarning: 'Printing from mobile is not optimal. Please use desktop for best print quality.',
    printErrorLoad: 'Could not load print data. Please try again.',
    printNotFound: 'Voucher not found. It may have been deleted or you do not have access.',
    printCrossTenant: 'You do not have permission to print this voucher (different branch).',
    maPhieu: 'Voucher code',
    thoiGian: 'Time',
    sdt: 'Phone',
    diaChi: 'Address',
    taiKhoanQuy: 'Account',
    kemTheo: 'Attachments',
    kemTheoEmpty: '—',
    kyGhiRoHoTen: '(Sign, print full name)',
    nguoiNop: 'Payer',
    hoTenNguoiNop: 'Payer full name',
    hoTenNguoiNhan: 'Recipient full name',
    nguoiDuyet: 'Approver',
    lyDoThu: 'Reason for receipt',
    lyDoChi: 'Reason for payment',
    congTy: 'Company',
    chiNhanh: 'Branch',
    qrLabel: 'QR code',
    maPhieuQrLabel: 'Voucher code: {maPhieu}',
    qrAriaLabel: 'QR code containing voucher {maPhieu}, scan to verify',
    empty: '—',
  },
  taiKhoanQuy: {
    title: 'Cash accounts',
    list: 'Cash account list',
    create: 'New cash account',
    update: 'Edit cash account',
    fields: {
      ma: 'Account code',
      ten: 'Account name',
      loai: 'Account type',
      soDuBanDau: 'Opening balance',
      soDuHienTai: 'Current balance',
      nganHang: 'Bank',
      soTaiKhoan: 'Account number',
      chiNhanh: 'Branch',
      trangThai: 'Status',
    },
  },
  audit: {
    title: 'Audit timeline',
    empty: 'No audit history yet.',
    xemTatCa: 'View all',
    thucHienBoi: 'by {actor}',
    thoiGianKhongHopLe: '--',
    actions: {
      create: 'Created',
      update: 'Updated',
      submit: 'Submitted for approval',
      approve: 'Approved',
      reject: 'Rejected',
      cancel: 'Cancelled',
      unknown: 'Other',
    },
  },
  // Story 4.3 — Cash book report page (FR-11 part 1).
  // 4 summary cards (opening balance / total receipts / total payments / closing balance)
  // + filter bar + refresh / error state.
  baoCao: {
    soDuDauKy: 'Opening balance',
    tongThu: 'Total receipts',
    tongChi: 'Total payments',
    soDuCuoiKy: 'Closing balance',
    sectionTongHop: 'Period summary',
    sectionChiTiet: 'Transaction details',
    chenhLech: 'Difference: {soTien}',
    tongCong: 'Total',
    breadcrumbSoQuy: 'Cash Book',
    subtitle: 'Track branch cash flow in the selected period',
    chiNhanhHint: 'Current branch',
    khongCoThuTrongKy: 'No receipts in this period.',
    khongCoChiTrongKy: 'No payments in this period.',
    loadErrorTitle: 'Could not load the cash book report.',
    refreshSuccess: 'Report refreshed.',
    xuatExcelDefer: 'Excel export will be available in the next release (Story 4.5).',
    // Story 4.5 — tooltip + aria-label cho nút [📥 Xuất Excel].
    xuatExcelInvalidKy: 'Please select a valid period',
    xuatExcelAriaLabel: 'Export cash book report to Excel',
    tu: 'From',
    den: 'To',
    filterPlaceholder: 'Search by account name, account no...',
    filterTenTaiKhoan: 'Cash account name',
    filterSoTaiKhoan: 'Account number',
  },
  summary: {
    tongThu: 'Total receipts',
    tongChi: 'Total payments',
    luyKe: 'Net',
  },
  labels: {
    lyDo: 'Reason',
    soDuTaiThoiDiemHint: 'Cash account balance at the time the receipt was issued.',
  },
  aria: {
    trangThai: 'Status: {label}',
    columnPicker: 'Choose visible columns',
  },
  // Story 4.4 — Receipt/payment ledgers (FR-11 part 2).
  bangKe: {
    thuTitle: 'Receipt ledger',
    chiTitle: 'Payment ledger',
    columns: {
      maPhieu: 'Voucher no.',
      thoiGian: 'Date',
      loaiThuChi: 'Category',
      soTien: 'Amount',
      nguoiTao: 'Created by',
    },
    emptyThu: 'No approved receipts in this period.',
    emptyChi: 'No approved payments in this period.',
    loadError: 'Could not load the ledger. Please try again.',
    refreshSuccess: 'Ledger refreshed.',
    xemChiTiet: 'View voucher details {maPhieu}',
    rowsPerPage: 'Rows per page:',
    // P7 (code review D1): clarify ledger is NOT filtered by cash account (only the 4 summary cards filter).
    subtitleAllChiNhanh: 'Branch-wide ledger (not filtered by the selected cash accounts)',
  },
  // Story 4.4 — Balance fluctuation chart (FR-11 part 2).
  bienDong: {
    title: 'Daily receipts/payments fluctuation',
    legendThu: 'Receipts',
    legendChi: 'Payments',
    legendSoDu: 'Closing balance',
    empty: 'No fluctuation data in this period.',
    requireTaiKhoanQuy: 'Please select at least 1 cash account to view the chart.',
    loadError: 'Could not load chart data. Please try again.',
    refreshSuccess: 'Chart refreshed.',
    mobileSummary: 'Total receipts: {tongThu}, Total payments: {tongChi}',
  },
  // Story 4.5 — Excel export flow (FR-12 wire-up).
  xuatExcel: {
    dangTaiFile: 'Downloading file...',
    dangTai: 'Loading...',
    thanhCong: 'Excel file downloaded.',
    matKetNoi: 'Connection lost. Please try again.',
    thamSoKhongHopLe: 'Invalid parameters. Please check the period.',
    khongCoQuyen: 'You do not have permission to export Excel.',
    loiHeThong: 'System error while exporting Excel. Please try again.',
  },
  loaiThuChi: {
    listTitle: 'Cashbook types',
    searchPlaceholder: 'Search by code or name...',
    filterLoaiAll: 'All kinds',
    filter: {
      textDetailTitle: 'Detailed filters',
    },
    filterSection: {
      loai: 'Kind',
      tatCa: 'All',
    },
    empty: 'No cashbook types yet.',
    listSummary: '{count} types total',
    fields: {
      ma: 'Code',
      loai: 'Kind',
      ten: 'Type name',
      maHintCreate: 'Leave blank to auto-generate (e.g. {example})',
      maHintEdit: 'Must start with {prefix}',
    },
    heThongBadge: 'System',
    actions: { taoMoi: 'Create new' },
    titles: {
      create: 'Create cashbook type',
      edit: 'Edit cashbook type',
      delete: 'Delete cashbook type',
    },
    validation: {
      tenRequired: 'Please enter a type name',
      maRequired: 'Please enter a type code',
      maInvalid: 'Code must be THUXXX or CHIXXX (e.g. THU001)',
      maLoaiMismatch: 'Code must start with {prefix}',
    },
    messages: {
      loadError: 'Could not load cashbook types.',
      createSuccess: 'Cashbook type created.',
      createError: 'Could not create cashbook type.',
      updateSuccess: 'Cashbook type updated.',
      updateError: 'Could not update cashbook type.',
      deleteSuccess: 'Cashbook type deleted.',
      deleteError: 'Could not delete cashbook type.',
      deleteConfirm: 'Delete cashbook type "{ten}"?',
    },
  },
}
